import React, { Component } from 'react';
import './style.css';

class PaymentRequest extends Component {
  constructor(props){
    super(props)
    this.state={
    };
    this.editMember = this.editMember.bind(this);
  }

  editMember(data){
    this.props.paymentReview(data);
  }

  reviewGiftCoupon(data){
    this.props.reviewGiftCouponPayment(data);
  }

  checkPaypalPayment(data){
    this.props.checkPaypalPayment(data);
  }

  render(){

    let membersDataList = "";
    if(this.props.paymentReqListSuccess){
    if(this.props.paymentReqList && this.props.paymentReqList.length){
      let members = this.props.paymentReqList;
      membersDataList = Object.keys(members).map((item, index) => {
      let membersItem = members[item];
        let showRivewButton="";
        if(membersItem.trans.paymentStatus === "DeclineByUser"){
          showRivewButton = <div>&nbsp;&nbsp; Decline By User</div>
        }else if(membersItem.trans.paymentStatus === "notConfirm"){
          showRivewButton = <div>&nbsp;&nbsp; Not Confirm BY User</div>
        }else if(membersItem.trans.paymentStatus === "success"){
          showRivewButton = <div>&nbsp;&nbsp; Completed</div>
        }else if(membersItem.trans.paymentStatus === "rejected"){
          showRivewButton = <div>&nbsp;&nbsp; Rejected</div>
        }else if(membersItem.trans.paymentStatus === "approved" && membersItem.trans.paymentType === "paypal"){
          showRivewButton = <button className = "edituserbtn" type="button" onClick={this.editMember.bind(this, membersItem)}  > Pay payment </button>
        }else if(membersItem.trans.paymentStatus === "processing" && membersItem.trans.paymentType === "paypal"){
          showRivewButton = <button className = "edituserbtn" type="button" onClick = {this.checkPaypalPayment.bind(this,membersItem)} > Verify payment </button>
        }else if(membersItem.trans.paymentStatus=== "unsuccess"){
          showRivewButton = <div>&nbsp;&nbsp; Unsucceeded</div>
        }else if(membersItem.trans.paymentType === "paypal"){
          showRivewButton = <button className = "edituserbtn" type="button" onClick={this.editMember.bind(this, membersItem)}  > Review </button>
        }else if(membersItem.trans.paymentType === "GiftCouponOnline" && membersItem.trans.paymentStatus === "approved"){
          showRivewButton = <button className = "edituserbtn" type="button" onClick={this.reviewGiftCoupon.bind(this, membersItem)}  > Assign coupons </button>
        }else if(membersItem.trans.paymentType === "GiftCouponOnline"){
          showRivewButton = <button className = "edituserbtn" type="button" onClick={this.reviewGiftCoupon.bind(this, membersItem)}  > Review </button>
        }

        //payment type 
        let newPaymentView = "";
        if(membersItem.trans.paymentType === "GiftCouponOnline"){
          newPaymentView = <div>Online Giftcoupon</div>
        }else if(membersItem.trans.paymentType === "GiftCouponOffline"){
          newPaymentView = <div>Offline Giftcoupon</div>
        }else if(membersItem.trans.paymentType === "paypal"){
          newPaymentView = <div>Paypal payment</div>
        }


      return <tr key={index} >
        <td>{index+1}</td>
        <td>{membersItem.users.First_name+ " "+ membersItem.users.Last_name}</td>
        <td>{membersItem.trans.totalAmount +" USD"}</td>
        <td>{membersItem.trans.totalPoints}</td>
        <td>{newPaymentView}</td>
        <td>{membersItem.trans.paymentStatus}</td>
        <td>{membersItem.trans.updatedAt.split("T")[0]+" "+membersItem.trans.updatedAt.split("T")[1].split(".")[0]}</td> 
        <td>{showRivewButton}</td>
        </tr>
        });
    }
  }else{
    membersDataList =
      <tr>
      Not found any transactions
      </tr>
  }

  return (
       
        <table className = "paymentTable">
          <thead>
            <tr>  
              <th >Sr.No.</th>
              <th>Name</th>
              <th>Amount</th>
              <th>Points</th>
              <th>Payment Type</th>
              <th>Payment Status</th>
              <th>Date & Time</th>
              <th>Action</th>
            </tr>
          </thead>
            <tbody>
           {membersDataList}
            </tbody>
        </table>
    
        
    );
  }
}
export default PaymentRequest;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/index.js